module.exports = __webpack_public_path__ + "ede7ec798b8998d959a372568bcbeb39.jpg";